export const themeStrings = {
  light: 'long',
  dark: 'short',
};
